import React, { useEffect, useState } from 'react'
import { Table } from "antd";
import Beatloader from '../../../../Common/Loaders/Beatloader';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { getMasterIATAAgentList } from '../../../../Redux/action/MasterAction';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import Swal from 'sweetalert2';
import { adminMainUrl } from '../../../../Config';
import { useFormik } from 'formik';

const IATAAgent = ({ accessedPermission }) => {

    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [showLoader, setshowLoader] = useState(false);

    const [country_id, setCountry_id] = useState(null);

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const queryParams = new URLSearchParams(location.search);


    useEffect(() => {
        if (token && user_id) {
            dispatch(getMasterIATAAgentList(token, user_id, queryParams.get("page") ?? 1, queryParams.get('search')));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, location.pathname, location.search]);

    const refresh = () => {
        if (token && user_id) {
            dispatch(getMasterIATAAgentList(token, user_id, queryParams.get("page") ?? 1, queryParams.get('search')));
        }
    }



    const {
        loadingMasterIATAAgentList,
        MasterIATAAgentList,
        MasterIATAAgentListError,
        MasterIATAAgentListCurrentPage,
        MasterIATAAgentListTotalPage,
        MasterIATAAgentListTotalData,

    } = useSelector(state => state?.MasterReducer);

    const [dataSource, setDataSource] = useState([]);
    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Name", dataIndex: "name", key: "name" },
        { title: "IATA Code", dataIndex: "iata_code", key: "iata_code" },
        { title: "Status", dataIndex: "status", key: "status" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];

    const handleChangeStatus = async (id) => {
        if (!id) { toast.error("Could not found id."); return; };
        try {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: "Do you want to change the status?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, change it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {
                axios.post(`${adminMainUrl}/api/iata-agent/status-change`, { id: id }, { headers: { "auth-token": token, "user_id": user_id } })
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            refresh();
                        } else {
                            toast.success(response.data.msg);
                        }
                    }).catch(error => {
                        console.log(error);
                        toast.error(error.message);
                    })
            }
        } catch (error) {
            console.error("Error changing status:", error);
            toast.error("An error occurred while changing the status.");
        }
    }

    useEffect(() => {
        if (loadingMasterIATAAgentList) {
            setshowLoader(true);
        } else {
            setshowLoader(false);
        }

        if (MasterIATAAgentList) {
            let arr = [];
            MasterIATAAgentList.map((val, i) => {
                arr.push({
                    key: i, // Add a unique key for each row
                    SNo: (queryParams.get("page") ? Number(queryParams.get("page")) - 1 : 0) * 10 + i + 1,
                    name: val.name ?? "-",
                    iata_code: val?.iata_code ?? "-",
                    status:
                        <>
                            <span id={`flexSwitchCheckChecked-${i}`}
                                title="Click to change status"
                                onClick={() => handleChangeStatus(val.id)}
                                className={`cursor-pointer ${val.status === true ? "badge badge-pill badge-status bg-success" : "badge badge-pill badge-status bg-danger"}`}>
                                {val.status === true ? "Active" : "Inactive"}
                            </span>
                        </>
                    ,
                    action: (
                        <>
                            <div className="dropdown table-action">
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                    <Link className="dropdown-item cursor-pointer" to={`/flexichain/iata-agent/edit/${btoa(val.id)}`}>
                                        <i className="ti ti-edit text-blue me-2"></i> Edit
                                    </Link>
                                    {/* New Change Status button below Edit */}
                                    <button
                                        className="dropdown-item cursor-pointer"
                                        onClick={() => handleChangeStatus(val.id)}
                                        style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left' }}
                                    >
                                        <i className="ti ti-refresh text-warning me-2"></i> Change Status
                                    </button>
                                </div>
                            </div>
                        </>
                    )
                })
            });
            setDataSource(arr);
        }
    }, [loadingMasterIATAAgentList, MasterIATAAgentList]);

    useEffect(() => {
        if (MasterIATAAgentListCurrentPage) {
            setCurrentPage(MasterIATAAgentListCurrentPage);
        }

        if (MasterIATAAgentListTotalPage) {
            setTotalPages(MasterIATAAgentListTotalPage)
        }
    }, [
        MasterIATAAgentListCurrentPage,
        MasterIATAAgentListTotalPage,
        MasterIATAAgentListTotalData
    ]);


    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };

    //search functionality
    let initialValues = {
        search_text: "",
    };
    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            const search_text = values.search_text.trim();
            const currentUrl = new URL(window.location.href);

            if (search_text) {
                currentUrl.searchParams.set("search", search_text);
            } else {
                currentUrl.searchParams.delete("search");
            }
            if (currentUrl.searchParams.has("page")) {
                currentUrl.searchParams.delete("page");
            }
            navigate(`${currentUrl.pathname}${currentUrl.search}`);
        }
    });

    useEffect(() => {
        if (queryParams.get("search")) {
            formik.setFieldValue("search_text", queryParams.get("search"))
        }
    }, [queryParams.get("search")])


    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            IATA Agent List<span className="count-title">{MasterIATAAgentListTotalData ?? "0"}</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row align-items-center">
                                    <div className="col-sm-4">
                                        <div className="icon-form mb-3 mb-sm-0">
                                            <span className="form-icon">
                                                <i className="ti ti-search" />
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Search "
                                                name='search_text'
                                                value={formik.values.search_text}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-8">

                                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                                            <button type='submit' className="btn btn-primary me-2">
                                                Search
                                            </button>

                                            {accessedPermission.includes("add_master_data") && (user_id == 2) && <Link
                                                className="btn btn-primary cursor-pointer"
                                                to={`/flexichain/iata-agent/add`}
                                            >
                                                <i className="ti ti-square-rounded-plus me-2" />
                                                Add IATA Agent
                                            </Link>}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div className="card-body">
                            {
                                showLoader ?
                                    <>
                                        <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                                            <Beatloader />
                                        </div>
                                    </> :
                                    <>
                                        <div className="table-responsive custom-table">
                                            <Table className="table datanew dataTable no-footer" pagination={false}
                                                dataSource={dataSource} columns={columns} />
                                        </div>
                                        <div className="row align-items-center">
                                            {dataSource.length ? <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                                <ReactPaginate
                                                    previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                    nextLabel={<img src="/img/left.png" alt="Next" />}
                                                    breakLabel="..."
                                                    breakClassName="break-me"
                                                    pageCount={totalPages}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="active"
                                                    forcePage={currentPage - 1}
                                                />
                                            </div> :
                                                null
                                            }
                                        </div>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default IATAAgent